import styled from 'styled-components';

export const ChangeVehicleFinanceCompanyContainer = styled.div.attrs({
  id: 'ChangeVehicleFinanceCompanyContainer',
})`
  width: 100%;
`;
export const ChangeVehicleFinanceCompanyField = styled.div.attrs({})`
  min-width: 200px;
`;

export const ChangeVehicleFinanceCompanyFieldHeader = styled.h4.attrs({
  id: 'ChangeVehicleFinanceCompanyFieldHeader',
})`
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 0.9rem;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeSpeed;
  margin-bottom: 8px;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;
export const RequiredField = styled.span.attrs({})`
  color: red;
`;
export const ChangeVehicleFinanceCompanyButtonsContainer = styled.div.attrs({
  id: 'changeVehicleFinanceCompanyButtonsContainer',
})`
  text-align: right;
  margin-right: 2%;
  margin-top: 10%;
  display: flex;
  width: 100%;
  @media (max-width: 384px) {
    text-align: center;
  }
`;
export const ChangeVehicleFinanceCompanyButton = styled.button.attrs({})`
  margin-left: 10px;
  padding: 10px 20px;
  background-color: ${(props) => props.theme.primaryColor};
  color: white;
  :disabled {
    background-color: gray;
  }
  @media (max-width: 385px) {
    margin-bottom: 16px;
  }
`;

export const ChangeVehicleFinanceCompanyNextButton = styled(
  ChangeVehicleFinanceCompanyButton,
).attrs({ id: 'Next' })``;
export const ChangeVehicleFinanceCompanySubmitButton = styled(
  ChangeVehicleFinanceCompanyButton,
).attrs({ id: 'Submit' })``;

export const ChangeVehicleFinanceCompanyTextAreaField = styled.textarea.attrs({
  id: 'changeVehicleFinanceCompanyTextAreaField',
})`
  height: 100px;
  margin-top: 5px;
  margin-bottom: 10px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;

export const ChangeVehicleFinanceCompanyTextInputField = styled.input.attrs({
  type: 'text',
})`
  height: 30px;
  width: 100%;
  @media (max-width: 599px) {
  }
  @media (min-width: 600px) and (max-width: 959px) {
  }
  @media (min-width: 900px) and (max-width: 1279px) {
  }
  @media (min-width: 1280px) {
  }
`;

export const ChangeVehicleFinanceCompanyNameInputField = styled(
  ChangeVehicleFinanceCompanyTextInputField,
).attrs({ id: 'name' })``;

export const ChangeVehicleFinanceCompanyLoanNumberInputField = styled(
  ChangeVehicleFinanceCompanyTextInputField,
).attrs({ id: 'loanNumber' })``;

export const ChangeVehicleFinanceCompanyComponent = styled.div.attrs({})`
  margin-bottom: 12px;
`;
export const ChangeVehicleFinanceCompanyRadioButton = styled.input.attrs({
  type: 'radio',
})`
  display: inline-block;
  vertical-align: top;
  margin-top: 2px;
  margin-left: 5px;
  margin-right: 5px;
  float: left;
`;
export const RadioLabel = styled.div.attrs({})`
  display: block;
  margin-left: 22px;
`;
export const LinkStyleButton = styled.button.attrs({
  id: 'Cancel',
})`
  background-color: initial;
  color: ${(props) => props.theme.primaryColor};
  box-shadow: none;
  cursor: pointer;
  margin-right: auto;
  margin-left: 0;

  :hover {
    background-color: initial;
    color: ${(props) => props.theme.primaryHoverColor};
  }
  :active {
    background-color: initial;
    color: ${(props) => props.theme.primaryActiveColor};
  }
`;
